import React from 'react';
import { HeadingLink, HeadingLinkProps } from './HeadingLink';

type ChameleonHeadingLinkProps = Omit<HeadingLinkProps, 'color'>;

export function ChameleonHeadingLink(props: ChameleonHeadingLinkProps) {
    return <HeadingLink {...props} color="chameleon" />;
}
